<template>
  <div class="slogn">
    <h2 class="title1">
      <span>
        {{ title1 }}
      </span>
    </h2>
    <h2 class="title2">{{ title2 }}</h2>
    <h3>{{ subTitle }}</h3>
  </div>
</template>

<script>
export default {
  props: {
    title1: {
      type: String,
      default: ''
    },
    title2: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.slogn {
  display: flex;
  flex-direction: column;
  h2.title1 {
    color: #fff;
    font-size: 36px;
    font-weight: 400;
    position: relative;
    span {
      padding-right: 20px;
      background: linear-gradient(90deg, rgba(38, 70, 130, 1)0%, $mainPurple 70%);
    }
    &:before {
      position: absolute;
      left: -100px;
      top: -2px;
      content: ' ';
      height: 51px;
      width: 100px;
      background: linear-gradient(90deg, rgb(255,255,255) 0%, rgba(38, 70, 130, 1) 40%);
    }
  }
  h2.title2 {
    color: $deepBlue;
    font-size: 36px;
    font-weight: 400;
  }
  h3 {
    color: $deepBlue;
    font-weight: 400;
    font-size: 24px;
    @include minWidth992 {
      font-size: 28px;
    }
  }
}
</style>
